module.exports = __webpack_public_path__ + "static/media/tel_aviv.fbcbf455.jpeg";